import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Laptop, Utensils, Bath, Venus, Wifi, BadgeEuro } from 'lucide-react';

const Home = () => {
  const { t } = useTranslation();
  const features = t('home.features', { returnObjects: true });
  const icons = [
    <Laptop key="laptop" className="w-7 h-7 mb-2 text-blue-700" />,
    <Utensils key="utensils" className="w-7 h-7 mb-2 text-blue-700" />,
    <Bath key="bath" className="w-7 h-7 mb-2 text-blue-700" />,
    <Venus key="venus" className="w-7 h-7 mb-2 text-blue-700" />,
    <Wifi key="wifi" className="w-7 h-7 mb-2 text-blue-700" />,
    <BadgeEuro key="euro" className="w-7 h-7 mb-2 text-blue-700" />
  ];
  return (
    <div className="pt-20 bg-blue-50 min-h-screen">
      {/* Banner */}
      <div className="bg-white text-blue-700 py-16 px-4 text-center border-b border-blue-100">
        <h1 className="text-4xl md:text-5xl font-extrabold mb-4 tracking-tight">{t('home.title')}</h1>
        <p className="text-lg md:text-xl mb-8 font-light">{t('home.desc')}</p>
        <Link to="/booking" className="inline-block bg-yellow-400 hover:bg-yellow-500 text-blue-900 font-bold py-3 px-8 rounded-lg text-lg shadow-sm transition-transform duration-150 hover:-translate-y-1 focus:outline-none focus:ring-2 focus:ring-blue-300">
          {t('home.bookNow')}
        </Link>
      </div>
      {/* 设施图标 */}
      <div className="container mx-auto mt-12 px-4">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-8 mb-12">
          {features.map((label, idx) => (
            <div key={label} className="flex flex-col items-center bg-white rounded-lg shadow-sm p-4">
              {icons[idx]}
              <span className="text-gray-700 text-sm text-center mt-1 font-medium">{label}</span>
            </div>
          ))}
        </div>
      </div>
      {/* 热门房型推荐 */}
      <div className="container mx-auto px-4 flex flex-col items-center justify-center mb-16">
        <h2 className="text-2xl md:text-3xl font-bold mb-8 text-blue-700 text-center tracking-wide">{t('home.popularRooms')}</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 w-full max-w-5xl">
          <div className="bg-white rounded-xl shadow-sm overflow-hidden flex flex-col border border-blue-100 hover:shadow-md transition-transform duration-150 hover:-translate-y-1">
            <img src="https://cf.bstatic.com/xdata/images/hotel/max1024x768/123456789.jpg" alt={t('home.room_8')} className="w-full h-48 object-cover" />
            <div className="p-6 flex-1 flex flex-col justify-between">
              <h3 className="text-lg font-bold mb-2 text-blue-800">{t('home.room_8')}</h3>
              <p className="text-gray-600 mb-2">{t('home.price_8')}</p>
              <Link to="/booking?roomType=8bed" className="block bg-blue-700 text-white text-center py-2 rounded-md hover:bg-blue-800 transition-colors mt-auto font-semibold">{t('home.book')}</Link>
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-sm overflow-hidden flex flex-col border border-blue-100 hover:shadow-md transition-transform duration-150 hover:-translate-y-1">
            <img src="https://cf.bstatic.com/xdata/images/hotel/max1024x768/987654321.jpg" alt={t('home.room_4')} className="w-full h-48 object-cover" />
            <div className="p-6 flex-1 flex flex-col justify-between">
              <h3 className="text-lg font-bold mb-2 text-blue-800">{t('home.room_4')}</h3>
              <p className="text-gray-600 mb-2">{t('home.price_4')}</p>
              <Link to="/booking?roomType=4bed" className="block bg-blue-700 text-white text-center py-2 rounded-md hover:bg-blue-800 transition-colors mt-auto font-semibold">{t('home.book')}</Link>
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-sm overflow-hidden flex flex-col border border-blue-100 hover:shadow-md transition-transform duration-150 hover:-translate-y-1">
            <img src="https://cf.bstatic.com/xdata/images/hotel/max1024x768/192837465.jpg" alt={t('home.room_female3')} className="w-full h-48 object-cover" />
            <div className="p-6 flex-1 flex flex-col justify-between">
              <h3 className="text-lg font-bold mb-2 text-blue-800">{t('home.room_female3')}</h3>
              <p className="text-gray-600 mb-2">{t('home.price_female3')}</p>
              <Link to="/booking?roomType=female3" className="block bg-blue-700 text-white text-center py-2 rounded-md hover:bg-blue-800 transition-colors mt-auto font-semibold">{t('home.book')}</Link>
            </div>
          </div>
        </div>
      </div>
      {/* 青旅介绍 */}
      <div className="container mx-auto px-4 mb-12">
        <div className="bg-white rounded-lg shadow-sm p-8 md:p-12 text-center max-w-3xl mx-auto border border-blue-100">
          <h2 className="text-2xl font-bold mb-4 text-blue-700">{t('home.about')}</h2>
          <p className="text-gray-700 mb-2 font-light">{t('home.aboutDesc')}</p>
          <p className="text-gray-700 font-light">{t('home.aboutNomad')}</p>
        </div>
      </div>
    </div>
  );
};

export default Home; 
